export default function PotvrdaUklanjanja({ radi, naPotvrdu, naOdustani }) {
  return (
    <div className="potvrda-uklanjanja">
      <p>
        Ukloniti spremljenu poziciju? Zapis i ostali podaci ostaju u evidenciji.
      </p>
      <div>
        <button className="gumb sek" disabled={radi} onClick={naOdustani}>
          Odustani
        </button>
        <button className="gumb" disabled={radi} onClick={naPotvrdu}>
          {radi ? 'Uklanjam…' : 'Ukloni poziciju'}
        </button>
      </div>
    </div>
  );
}
